export default __webpack_public_path__ + "static/media/item-2.61373cb8.webp";